<div class="review-banner">
  <form [formGroup]="form" class="w-full">
    <div class="flex justify-between w-full">
      <div class="flex items-center">
        <h4>{{title}}</h4>
        <mat-radio-group formControlName="status">
          @if(displayApprove()) {
          <mat-radio-button value="Approve">Approve</mat-radio-button>
          }
          @if(displayDeclined()) {
          <mat-radio-button value="Decline">Decline</mat-radio-button>
          }
          @if(displayMoreInfo()) {
          <mat-radio-button value="MoreInfo">Requires More Info</mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="'Submit'" [size]="'large'"
        (click)="submit()"></lib-button>
    </div>
    @if(proposedEffectiveDate() !== null) {
      <div class="flex flex-col w-full gap-4 text-left">
        <p class="font-bold">Quoted Policy Effective Date: {{effectiveDate() ? (effectiveDate() | date:'MM/dd/yyyy') : null}}</p>
        <p class="font-bold" style="color: red">Requested Policy Effective Date: {{proposedEffectiveDate() | date:'MM/dd/yyyy'}}</p>
      </div>
      }
      @if(displayExclusion()) {
        <div class="flex w-full gap-4">
          <lib-form-dropdown class="width-inherit" formControlName="updatePolicyEffectiveDate"
            label="Do you wish to update the policy effective date?"
            [manualOptions]="[{value: true, name:'Yes'} , {value:false, name:'No'}]">
          </lib-form-dropdown>
          <lib-custom-date-picker class="width-inherit" label="Policy Effective Date" formControlName="policyEffectiveDate" [minDate]="minEffectiveDate" [maxDate]="maxEffectiveDate"></lib-custom-date-picker>
        </div>
        <div class="flex w-full gap-4">
          <lib-form-dropdown class="width-inherit" formControlName="removePriorWork"
            label="Remove Exclusion for Prior Completed or Abandoned Work?"
            [manualOptions]="[{value: true, name:'Yes'} , {value:false, name:'No'}]">
          </lib-form-dropdown>
          @if(displayExclusionDate()) {
            <lib-custom-date-picker class="width-inherit" formControlName="priorWorksEffectiveDate" label="Prior Works Exclusion Date"></lib-custom-date-picker>
          }
        </div>
      }
      @if(displayComments()) {
        <lib-form-text-area class="w-full" formControlName="comments" label="Underwriting Comments" [rows]="5"></lib-form-text-area>
      }
  </form>
</div>